/**
 * Market pricing benchmarks [low, mid, high]
 * Based on publicly available distributor/market data (2025)
 * Used for market comparison column in quotes
 */
export const MKT = {
  soft: {
    0:    [1200, 1600, 2200],   // NEMA 0 (<=3HP)
    1:    [1800, 2500, 3400],   // NEMA 1 (<=10HP)
    3:    [4200, 5800, 7800],   // NEMA 3 (15HP)
    5:    [14000,19000,26000],  // NEMA 5 (75HP)
    ctrl: [1200, 1600, 2200],  // Control/feeder bucket
  },
  vfd: {
    0:    [1800, 2400, 3200],
    1:    [2600, 3500, 4800],
    3:    [5500, 7500, 10000],
    5:    [22000,30000,42000],
    ctrl: [1200, 1600, 2200],
  },
  structure: {
    indoor12:  [4500,  6000,  8500],   // NEMA 12 per section
    outdoor4X: [9000, 13000, 18000],   // NEMA 4X SS per section
  },
  mainBreaker: [8000,  12000, 18000],
  bus:         [600,   900,   1400],   // per section
  spd:         [2500,  3500,  5000],
  meter:       [1800,  2500,  4000],
  xfmr:        [3500,  5000,  7500],
  pdp:         [2000,  3000,  4500],
  enip:        [3000,  4500,  6500],   // per lineup
  cpt:         [800,   1100,  1800],   // per section
  psu24:       [1200,  1800,  2800],   // per lineup
};

export const FREIGHT_ROUTES = {
  "Omaha, NE -> Mohave, AZ":    { miles: 1480 },
  "Omaha, NE -> Phoenix, AZ":   { miles: 1620 },
  "Omaha, NE -> Las Vegas, NV": { miles: 1580 },
  "Custom Route":               { miles: 1480 },
};

// DAT Freight & Analytics March 2026 national averages
export const FREIGHT_RATES = {
  ftl_flatbed: 2.94,
  ftl_van:     2.65,
  ltl:         2.20,
};
